import { Box, Container, Typography } from "@mui/material";

const MaintenanceLoader = () => {
  return (
    <Container>
      <Box sx={{ marginTop: "3.75rem" }} />
      <Typography variant="h4">Site is Under Maintenance!</Typography>
    </Container>
  );
};

export default MaintenanceLoader;
